import type { FunctionComponent } from 'react';
import type { TopicDto } from '../../../api/generated/client';
import { NeedDetailPanel } from './NeedDetailPanel';
import { TopicDetailPanel } from './TopicDetailPanel';
import { TopicListPanel } from './TopicListPanel';

export interface IPanelProps {
    isKeyQuestionSelected: boolean;
    isAdvNeedSelected: boolean;
    isPresentationMode?: boolean;
    containerDimensionsHeight: number;
    showBackButton?: boolean;
    topic: TopicDto;
}

export const TopicPanel: FunctionComponent<IPanelProps> = ({
    isKeyQuestionSelected,
    isAdvNeedSelected,
    isPresentationMode,
    containerDimensionsHeight,
    showBackButton,
    topic,
}) => {
    if (isPresentationMode && !isKeyQuestionSelected) {
        return <TopicListPanel topic={topic} containerDimensionsHeight={containerDimensionsHeight} />;
    }
    if (isKeyQuestionSelected && !isAdvNeedSelected) {
        return <TopicDetailPanel containerDimensionsHeight={containerDimensionsHeight} showBackButton={showBackButton} />;
    }
    if (isAdvNeedSelected) {
        return <NeedDetailPanel containerDimensionsHeight={containerDimensionsHeight} />;
    }

    return null;
};
